module.exports = __webpack_public_path__ + "img/20190702162045989.861acde5.png";